import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HandlingUnitItemFacade } from './handling-unit-item.facade';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { HandlingUnitOverviewFacade } from './overview/handling-unit-overview.facade';

@Injectable({
  providedIn: 'root',
})
export class HandlingUnitItemGuard {
  constructor(
    private handlingUnitItemFacade: HandlingUnitItemFacade,
    private handlingUnitOverviewFacade: HandlingUnitOverviewFacade,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { handlingUnitNumber },
      queryParams: { deliveryNoteNumber, sapId, parentRoute, monitoringPageType },
    } = route;
    this.handlingUnitItemFacade.setHandlingUnitParams({
      deliveryNoteNumber,
      handlingUnitNumber,
      sapId,
      parentRoute: parentRoute ? JSON.parse(parentRoute) : parentRoute,
      monitoringPageType,
    });
    return loadStoreState(this.handlingUnitOverviewFacade, {
      deliveryNoteNumber,
      handlingUnitNumber,
    });
  }

  canDeactivate(): boolean {
    setInitialStoreState(this.handlingUnitOverviewFacade);
    return setInitialStoreState(this.handlingUnitItemFacade);
  }
}
